import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=83d44822&lang=pug"
import script from "./confirmDialog.vue?vue&type=script&lang=ts"
export * from "./confirmDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports